import axios from 'axios';
import { setSettingLoader } from '../actions/settingActions';
import { REACT_APP_TEAMCAMP_APIURL } from '../global/environment';
import { AnyAction, Dispatch } from 'redux';
import { captureException } from './logService';
import { getAPIErrorReason } from '../helpers/common';
import { rootStore } from '../mobx/rootStore';
import { VercelProject } from '../mobx/interfaces/project';

/**
 * @desc vercel auth
 * @param {*}
 */
export const vercelIntegration: any = (payload: any) => async (dispatch: Dispatch<AnyAction>) => {
  try {
    dispatch(setSettingLoader(true));
    const response = await axios.post(`${REACT_APP_TEAMCAMP_APIURL}/vercel/auth`, payload);
    if (response) return true;
    return false;
  } catch (e) {
    const error = getAPIErrorReason(e) || 'Unable to- vercel integration! please try again';
    captureException(error, 'settings');
    dispatchVercelError(error);
    return false;
  } finally {
    dispatch(setSettingLoader(false));
  }
};

/**
 * @desc get dynamic vercel account
 * @param {*}
 */
export const getVercelAccount: any = () => async (dispatch: Dispatch<AnyAction>) => {
  try {
    dispatch(setSettingLoader(true));
    const response = await axios.get(`${REACT_APP_TEAMCAMP_APIURL}/vercel/accounts`);
    const { data } = response;
    if (data) {
      return data;
    }
    return false;
  } catch (e) {
    const error = getAPIErrorReason(e) || 'Unable to get vercel account please try again';
    captureException(error);
    dispatchVercelError(error);
    return false;
  } finally {
    dispatch(setSettingLoader(false));
  }
};

/**
 * @desc delete vercel account
 * @param {string} vercelId - ID of the task group to delete
 */
export const deleteVercelAccount: any = (vercelId: string) => async (dispatch: Dispatch<AnyAction>) => {
  try {
    dispatch(setSettingLoader(true));
    const response = await axios.delete(`${REACT_APP_TEAMCAMP_APIURL}/vercel/accounts/${vercelId}/remove`);
    if (response) {
      dispatchTaskSuccess('Vercel account deleted successfully');
      return true;
    }
    return false;
  } catch (e) {
    const error = getAPIErrorReason(e) || 'Unable to delete vercel account please try again';
    captureException(error);
    dispatchVercelError(error);
    return false;
  } finally {
    dispatch(setSettingLoader(false));
  }
};

/**
 * @desc Get Vercel Project list
 * @param {*}
 */
export const getVercelProjectList: any = () => async (dispatch: Dispatch<AnyAction>) => {
  try {
    dispatch(setSettingLoader(true));
    const response = await axios.get(`${REACT_APP_TEAMCAMP_APIURL}/vercel/projects`);
    if (response) {
      return response.data;
    }
    return false;
  } catch (e) {
    const error = getAPIErrorReason(e) || 'Unable to get vercel project list! please try again';
    captureException(error);
    dispatchVercelError(error);
    return false;
  } finally {
    dispatch(setSettingLoader(false));
  }
};

/**
 * @desc Get Vercel Project list
 * @param {*}
 */
export const setVercelProject: any =
  (projectID: string, payload: VercelProject) => async (dispatch: Dispatch<AnyAction>) => {
    try {
      dispatch(setSettingLoader(true));
      const response = await axios.post(`${REACT_APP_TEAMCAMP_APIURL}/vercel/projects/${projectID}`, payload);
      if (response) {
        return response;
      }
      return false;
    } catch (e) {
      const error = getAPIErrorReason(e) || 'Unable to set vercel project! please try again';
      captureException(error);
      dispatchVercelError(error);
      return false;
    } finally {
      dispatch(setSettingLoader(false));
    }
  };

/**
 * @desc Get Task Vercel Deployment
 * @param {string} projectId - ID of the project whose task branch is to deploy
 * @param {string} taskId - ID of the task which vercel deployment to get
 */
export const getVercelDeployment: any =
  (projectID: string, taskId: string) => async (dispatch: Dispatch<AnyAction>) => {
    try {
      dispatch(setSettingLoader(true));
      const response = await axios.get(
        `${REACT_APP_TEAMCAMP_APIURL}/vercel/projects/${projectID}/task/${taskId}/deployments`
      );
      const { data } = response;
      if (data) {
        rootStore.taskStore.currentTask?.setVercelDeployment(data);
        return data;
      }
      return false;
    } catch (e) {
      const error = getAPIErrorReason(e) || 'Unable to get vercel branch deployment! please try again';
      captureException(error);
      dispatchVercelError(error);
      return false;
    } finally {
      dispatch(setSettingLoader(false));
    }
  };

/**
 * @desc Get Task Vercel Deployment
 * @param {string} payload - projectId and branchName
 */
export const createBranchDeployment: any =
  (payload: { projectId: string; branchName: string }) => async (dispatch: Dispatch<AnyAction>) => {
    try {
      dispatch(setSettingLoader(true));
      const response = await axios.post(`${REACT_APP_TEAMCAMP_APIURL}/vercel/create-deploy`, payload);
      if (response) {
        return response;
      }
      return false;
    } catch (e) {
      const error = getAPIErrorReason(e) || 'Unable to set vercel project! please try again';
      captureException(error);
      dispatchVercelError(error);
      return false;
    } finally {
      dispatch(setSettingLoader(false));
    }
  };

function dispatchVercelError(msg: string) {
  rootStore.alertNotificationStore.setErrorMessage(msg);
}

function dispatchTaskSuccess(msg: string) {
  rootStore.alertNotificationStore.setSuccessMessage(msg);
}
